import React, { PureComponent } from "react";
import VisibilitySensor from "react-visibility-sensor";

import styles from "./Directory.local.scss";
import classnames from "classnames";
import _ from "i18n";

import { TTP_TALK_URL } from "Config";
import { getRandomColor } from "Utils";
import { SendingWidget } from "../../../../sending-widget";
import { TTP_EMAILING_URL } from "../../../../config";

export default class DirectoryComponent extends PureComponent {
  state = {
    listElement: null
  };

  sendingWidget = null;

  componentDidMount() {
    setTimeout(() => {
      const listElement = document.getElementById("directories-list");
      this.setState({ listElement });
    });

    if (!this.sendingWidget) {
      this.sendingWidget = new SendingWidget({
        url: TTP_EMAILING_URL
      });
    }
  }

  componentWillUnmount() {
    if (this.sendingWidget) {
      this.sendingWidget = null;
    }
  }

  loadMore = isVisible => {
    const { directories } = this.props;
    if (!isVisible || (directories && directories.length === 1)) {
      return;
    }

    if (this.props.loadMore) {
      this.props.loadMore();
    }
  };

  openRoom(folderId) {
    let roomUrl = `${TTP_TALK_URL}/duo/DUO-ROOM-${folderId}`;

    setTimeout(() => {
      const $widget = $(`.talk-widget`);
      const $trigger = $widget.find(".talk-trigger");
      const iframe = $widget.find("iframe").get(0);

      const widgetOpened = $trigger.hasClass("talk-trigger--active");

      if (!widgetOpened) {
        $trigger.click();
      }

      if (iframe && iframe.contentWindow) {
        const data = {
          url: roomUrl,
          eventName: "talk:open-url"
        };
        iframe.contentWindow.postMessage(data, "*");
      }
    });
  }

  initEmail = directory => {
    const { language } = this.props;
    const { id, email, legalRepresentative } = directory;

    const { mainEmail } = legalRepresentative;
    if (!this.sendingWidget) {
      return;
    }
    this.sendingWidget.showEmailWidget({
      recipientId: id,
      recipientType: "CONTACT",
      email: email || mainEmail || "",
      language
    });
  };

  renderFetching() {
    const { fetching } = this.props;

    if (!fetching) {
      return;
    }

    return (
      <React.Fragment>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
        <li className={styles.fetching}>
          <span />
        </li>
      </React.Fragment>
    );
  }

  renderDirectories() {
    const { directories = [], openEbox } = this.props;

    return (
      <ul id="directories-list">
        {directories.map(directory => {
          const {
            legalRepresentative,
            id,
            abbreviation,
            name,
            email,
            chatActivated
          } = directory;

          const { mainPhone, mainEmail, firstName } = legalRepresentative;

          return (
            <li
              key={id + (abbreviation ? abbreviation : name)}
              className="grid-x"
            >
              <span className={classnames("cell small-3", styles.lenght)}>
                <span className={styles.info}>
                  {abbreviation ? abbreviation : name}
                </span>
              </span>

              <span className="cell small-2">
                <span className={styles.info}>
                  {mainPhone ? mainPhone : "-"}
                </span>
              </span>
              <span className={classnames("cell small-4", styles.lenght)}>
                <span className={styles.info}>
                  {email ? email : mainEmail ? mainEmail : "-"}
                </span>
              </span>
              <span className={classnames("cell small-1", styles.ebox)}>
                <img
                  src="/img/icons/ebox.svg"
                  alt="envelope"
                  onClick={openEbox.bind(this, legalRepresentative)}
                />
                <img
                  src="/img/icons/send.svg"
                  alt="envelope"
                  onClick={this.initEmail.bind(this, directory)}
                />
                {/*}<span>12</span>*/}
              </span>
              {chatActivated ? (
                <span
                  className={classnames("cell small-2", styles.talk)}
                  onClick={() => this.openRoom(id)}
                >
                  <span
                    style={{ backgroundColor: getRandomColor() }}
                    className={styles.avatar}
                  >
                    {firstName[0]}
                  </span>
                  {/*}<span className={styles.notReaded}>3</span>*/}
                </span>
              ) : null}
            </li>
          );
        })}

        {this.renderFetching()}
        {this.renderVisibilitySensore()}
      </ul>
    );
  }

  renderVisibilitySensore = () => {
    if (!this.state.listElement || !this.props.hasMore || this.props.fetching) {
      return;
    }

    return (
      <VisibilitySensor onChange={this.loadMore}>
        {({ isVisible }) => (
          <li className="grid-x" style={{ visibility: "hidden" }}>
            <span className="cell small-4" style={{ height: "1.5rem" }}>
              VisibilitySensor is {isVisible ? "visible" : "invisible"}
            </span>
          </li>
        )}
      </VisibilitySensor>
    );
  };

  render() {
    return (
      <div className={classnames(styles.directory)}>
        <div className={classnames(styles.details)}>
          <div className={classnames(styles.header, "grid-x")}>
            <span className="cell small-3">{_("Organisation")}</span>
            <span className="cell small-2">{_("Phone")}</span>
            <span className="cell small-4">{_("Email")}</span>
            <span className={classnames("cell small-1", styles.ebox)}>
              {_("E-box")}
            </span>
            <span
              className={classnames(
                "cell small-2",
                styles.talk,
                styles.talkTitle
              )}
            >
              {_("Talk")}
              <span className={styles.duo}>Duo</span>
            </span>
          </div>
          {this.renderDirectories()}
        </div>
      </div>
    );
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Community/WorkPlace/Directory/DirectoryComponent.js